import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    // 全局状态
    state: {
        // 用户信息（从本地存储读取）
        userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
        // 发布的信息（本地存储）
        publishInfoList: JSON.parse(localStorage.getItem('publishInfoList')) || []
    },
    // 同步修改状态
    mutations: {
        // 设置用户信息
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
        },
        // 添加发布的信息
        ADD_PUBLISH_INFO(state, info) {
            state.publishInfoList.unshift(info)
            localStorage.setItem('publishInfoList', JSON.stringify(state.publishInfoList))
        },
        // 删除发布的信息
        DELETE_PUBLISH_INFO(state, id) {
            state.publishInfoList = state.publishInfoList.filter(info => info.id !== id)
            localStorage.setItem('publishInfoList', JSON.stringify(state.publishInfoList))
        },
        // 退出登录（清空用户信息）
        LOGOUT(state) {
            state.userInfo = {}
            localStorage.removeItem('userInfo')
            // 可选：保留发布的信息，如需清空可取消注释
            // state.publishInfoList = []
            // localStorage.removeItem('publishInfoList')
        }
    },
    // 异步操作
    actions: {
        // 退出登录
        logout({commit}) {
            commit('LOGOUT')
        },
        // 发布信息
        publishInfo({commit, state}, info) {
            return new Promise(resolve => {
                // 补充基础信息
                const newInfo = {
                    id: Date.now(),
                    publisher: state.userInfo.username,
                    phone: state.userInfo.phone,
                    publishTime: new Date().toLocaleString(),
                    ...info
                }
                commit('ADD_PUBLISH_INFO', newInfo)
                resolve(newInfo)
            })
        }
    },
    // 计算属性
    getters: {
        // 判断是否登录
        isLogin: state => !!state.userInfo.token,
        // 获取用户认证类型
        authType: state => state.userInfo.authType || 'unauth',
        // 获取用户发布的信息
        userPublishInfo: state => state.publishInfoList.filter(info => info.phone === state.userInfo.phone)
    }
})
